import React from "react";
import { Grid, TextField, MenuItem } from "@mui/material";
import { Field } from "formik";
import { childrenOf } from "../helpers/productForm.utils";

export default function ProductCategoryFields({ categories, values, errors, touched, setFieldValue }) {
  const rootCategories = categories.filter((c) => c.parentCategoryId == null);

  return (
    <>
      {/* קטגוריה ראשית */}
      <Grid item xs={12} md={6}>
        <Field
          as={TextField}
          select
          name="parentCategoryId"
          label="קטגוריה ראשית"
          fullWidth
          value={values.parentCategoryId}
          onChange={(e) => {
            const newParentId = Number(e.target.value);
            setFieldValue("parentCategoryId", newParentId);
            setFieldValue("categoryId", 0);
            setFieldValue("subCategoryId", 0);
          }}
          helperText={touched.parentCategoryId && errors.parentCategoryId ? errors.parentCategoryId : ""}
          error={touched.parentCategoryId && Boolean(errors.parentCategoryId)}
        >
          <MenuItem value={0} disabled>
            בחרי קטגוריה
          </MenuItem>
          {rootCategories.map((cat) => (
            <MenuItem key={cat.id} value={cat.id}>
              {cat.nameCategor}
            </MenuItem>
          ))}
        </Field>
      </Grid>

      {/* תת קטגוריה */}
      <Grid item xs={12} md={6}>
        <Field
          as={TextField}
          select
          name="categoryId"
          label="תת קטגוריה"
          fullWidth
          value={values.categoryId}
          onChange={(e) => {
            setFieldValue("categoryId", Number(e.target.value));
            setFieldValue("subCategoryId", 0);
          }}
          disabled={!values.parentCategoryId || childrenOf(categories, values.parentCategoryId).length === 0}
          helperText={touched.categoryId && errors.categoryId ? errors.categoryId : ""}
          error={touched.categoryId && Boolean(errors.categoryId)}
        >
          <MenuItem value={0} disabled>
            {childrenOf(categories, values.parentCategoryId).length
              ? "בחרי תת קטגוריה"
              : "אין תתי קטגוריות לקטגוריה זו"}
          </MenuItem>

          {childrenOf(categories, values.parentCategoryId).map((sub) => (
            <MenuItem key={sub.id} value={sub.id}>
              {sub.nameCategor}
            </MenuItem>
          ))}
        </Field>
      </Grid>

      {/* תת תת קטגוריה */}
      <Grid item xs={12} md={6}>
        <Field
          as={TextField}
          select
          name="subCategoryId"
          label="תת תת קטגוריה"
          fullWidth
          value={values.subCategoryId}
          onChange={(e) => setFieldValue("subCategoryId", Number(e.target.value))}
          disabled={!values.categoryId || childrenOf(categories, values.categoryId).length === 0}
        >
          <MenuItem value={0} disabled>
            {childrenOf(categories, values.categoryId).length
              ? "בחרי תת תת קטגוריה"
              : "אין תת תת קטגוריות לתת קטגוריה זו"}
          </MenuItem>

          {childrenOf(categories, values.categoryId).map((sub2) => (
            <MenuItem key={sub2.id} value={sub2.id}>
              {sub2.nameCategor}
            </MenuItem>
          ))}
        </Field>
      </Grid>
    </>
  );
}
